export class Layout {
  public id?: string;
  public description: string;
}

export class LayoutDetail {
  public id?: number;
  public layout_id: number;
  public row_position: number;
  public row_description: string;
  public row_max_lenght: number;
  public start_offset: number;
  public flg_print: number;
}





// WEBPACK FOOTER //
// ./src/app/models/loyalty-layout.model.ts